'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'PLUGINS_BY_CUSTOMERS',
    chartType = 'POINT_IN_TIME',
    filters = [config.filters.DATE],
    dataRotateMapping = [{
        'field': 'facebookEnabled',
        name: 'Facebook'
    }, {
        'field': 'twitterEnabled',
        name: 'Twitter'
    }, {
        'field': 'linkedInEnabled',
        name: 'LinkedIn'
    }, {
        'field': 'googlePlusEnabled',
        name: 'Google Plus'
    }, {
        'field': 'instagramEnabled',
        name: 'Instagram'
    }, {
        'field': 'foursquareEnabled',
        name: 'Foursquare'
    }, {
        'field': 'weChatEnabled',
        name: 'WeChat'
    }, {
        'field': 'guestBookEnabled',
        name: 'Guestbook'
    }, {
        'field': 'radiusEnabled',
        name: 'RADIUS'
    }, {
        'field': 'smsEnabled',
        name: 'SMS'
    }, {
        'field': 'webFormEnabled',
        name: 'Web Form'
    }, {
        'field': 'clickThroughEnabled',
        name: 'Clickthrough'
    }],
    dataSeries = {
        TIMESTAMP: 'timestamp',
        WEBFORM_ENABLED: 'webFormEnabled',
        GUESTBOOK_ENABLED: 'guestBookEnabled',
        WECHAT_ENABLED: 'weChatEnabled',
        FOURSQUARE_ENABLED: 'foursquareEnabled',
        INSTAGRAM_ENABLED: 'instagramEnabled',
        LINKEDIN_ENABLED: 'linkedInEnabled',
        RADIUS_ENABLED: 'radiusEnabled',
        FACEBOOK_ENABLED: 'facebookEnabled',
        GPLUS_ENABLED: 'googlePlusEnabled',
        TWITTER_ENABLED: 'twitterEnabled',
        SMS_ENABLED: 'smsEnabled',
        CLICKTHROUGH_ENABLED: 'clickThroughEnabled'
    },
    fieldNames = {
        WEBFORM_ENABLED: 'gmsPortalWebFormEnabledCount',
        GUESTBOOK_ENABLED: 'gmsPortalGuestBookEnabledCount',
        WECHAT_ENABLED: 'gmsPortalWeChatEnabledCount',
        FOURSQUARE_ENABLED: 'gmsPortalFoursquareEnabledCount',
        INSTAGRAM_ENABLED: 'gmsPortalInstagramEnabledCount',
        LINKEDIN_ENABLED: 'gmsPortalLinkedInEnabledCount',
        RADIUS_ENABLED: 'gmsPortalRADIUSEnabledCount',
        FACEBOOK_ENABLED: 'gmsPortalFacebookEnabledCount',
        GPLUS_ENABLED: 'gmsPortalGPlusEnabledCount',
        TWITTER_ENABLED: 'gmsPortalTwitterEnabledCount',
        SMS_ENABLED: 'gmsPortalSMSEnabledCount',
        CLICKTHROUGH_ENABLED: 'gmsPortalClickthroughEnabledCount'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: generatePluginAggregatorQuery(dataSeries, fieldNames)
    }],
    dataSeriesFields = ['plugins', 'pluginCount', 'customerPercentage'],
    modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
    aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
    tasks = [
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser', {
            name: 'afterApiAggregationCustomerPercentage',
            config: {
                aggregationFields: aggregationFields
            }
        }, {
            plugin: modifyResponse
        }, {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.CUSTOMERS_BY_PLUGINS;

var totalCustomers = 0;

function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {},
        pluginName,
        pluginFieldName;
        totalCustomers = model.totalCustomers;

    _.forEach(dataRotateMapping, function(singlePluginMapping) {
        pluginName = singlePluginMapping.name;
        pluginFieldName = singlePluginMapping.field;

        if (!computedModel.plugins) {
            computedModel.plugins = [];
        }
        computedModel.plugins.push(pluginName);

        if (!computedModel.pluginCount) {
            computedModel.pluginCount = [];
            computedModel.customerPercentage = [];
        }
        computedModel.pluginCount.push(model[pluginFieldName]);
        computedModel.customerPercentage.push(model[pluginFieldName+'_percentage']);

        delete model[pluginName];
    });

    if ($u.charts.allEqualElemArray(computedModel.pluginCount, 0) ||
        $u.charts.allEqualElemArray(computedModel.pluginCount, null)
    ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        pointWidth = width / 50,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var yAxisBaseUnit = '',
        yAxisRoundOff = true,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
	    yAxisTrimDecimalPlaces = 2;

    var y1Max = _.max(data.customerPercentage), y2Max = _.max(data.pluginCount);
    
    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Plugins',
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);
                
                return $u.charts.sformat('{0} of {1} customers ({2} %)',
                    data.pluginCount[this.point.x], totalCustomers, tooltipUnitObj.value);
            },
            percentageDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.plugins,
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return this.value;
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: GRAPHS.CHART_METADATA.FEATURES_BY_CUSTOMERS.YAXIS1_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value + '%';
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            endOnTick: false,
            max:y1Max,
            tickLength: 5,
            tickWidth: 1,
            gridLineWidth: 0,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        },{
            allowDecimals: false,
            title: {
                text: GRAPHS.CHART_METADATA.FEATURES_BY_CUSTOMERS.YAXIS2_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, false).value; // no rounding off
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: 10
            },
            opposite: true,
            min: 0,
            endOnTick: false,
            max:y2Max,
            tickLength: 5,
            tickWidth: 1,
            gridLineWidth: 0,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
            showInLegend: false,
            name: '% of Customers',
            data: data.customerPercentage,
            yAxis: 0,
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        },{
            showInLegend: false,
            name: 'No. of Customers',
            data: data.pluginCount,
            yAxis: 1,
            visible: false,
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}

function generatePluginAggregatorQuery(dataSeriesObj, fieldNamesObj) {
    var returnArray = [];
    _.forEach(_.keys(dataSeriesObj), function(pluginKey) {
        if (pluginKey !== 'TIMESTAMP') {
            returnArray.push({
                type: 'javascript',
                name: dataSeriesObj[pluginKey],
                fieldNames: [fieldNamesObj[pluginKey]],
                'fnAggregate': $d.aggregateFunction,
                'fnCombine': $d.aggregateCombineFunction,
                'fnReset': $d.aggregateResetFunction
            });
        }
    });
    return returnArray;
}
